const newFormModel = ({data, shape, validation = false}) => {
  let dataClone = {};
  for (const [key] of Object.entries(shape)) {
    if (!validation) {
      let value = data ? data[key] : shape[key].default;
      // Ensure date/datetime values are Date objects, not strings
      if (value && (shape[key].type === 'datetime' || shape[key].type === 'date') && typeof value === 'string') {
        value = new Date(value);
      }
      dataClone[key] = value;
    } else {
      if (shape[key].validation) {
        dataClone[key] = shape[key].validation;
      }
    }
  }
  return dataClone;
}

export { newFormModel };
